/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Purchase {

    import fld = ApprovalInReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ApprovalInReturnItemsEditor extends _Ext.ItemGridEditor<ApprovalInReturnItemsRow> {

        protected getColumnsKey() { return "Purchase.ApprovalInReturnItems"; }
        protected getDialogType() { return ApprovalInReturnItemsDialog; }
        protected getLocalTextPrefix() { return ApprovalInReturnItemsRow.localTextPrefix; }
        protected form: ApprovalInReturnItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        public TotalItems: number;
        //For RM Setup
        public ProductTypeId: number;
        statement: string;
        static baseitemcheck: number;
        //validate pieces and weight on new creation
        public pieces = [];
        public weight = [];
        public itemids = [];
        public isUpdate: number;
        public canUpdate: number;
        // #endregion

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as Purchase.ApprovalInReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            });
        }

        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Weight).format = wt;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }

        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            //To Set Master Product Image
            ApprovalInReturnDialog.image = item.ImageName;

            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();
                if (target.hasClass('edit numeric')) {
                    if (target.hasClass('edit numeric')) {
                        // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                        //TODO: Need to add System Parameter to enable disable blocking
                        var input = $(e.target);
                        if (input != undefined) {
                            var input = $(e.target);
                            var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                            if (this.canUpdate == 0) {
                                //Check Editable
                                target.addClass('readonly');
                                target.blur();
                                Q.alert("Readonly Detected")

                            } else if (this.canUpdate == 1) {
                                target.removeClass('readonly');
                                var input = $(e.target);
                                var y = input.data();
                                if (y.field == "Weight" && item.ItemTypeId == 101) {
                                    target.addClass('readonly');
                                    target.blur();
                                }
                                else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                                    target.addClass('readonly');
                                    target.blur();
                                }
                            }

                        }
                    }
                    (this.parentDialog as Purchase.ApprovalInReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

                    this.view.refresh();
                }
            }
        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;




            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            // *** Validate Decimal & Integer***
            else if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }


            let issuedItem: ApprovalInItemsRow; 
            Stock.StockItemService.GetReturnValues({
                ProductId: item.ProductId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                BagNo: item.BagNo,
                PartyId: item.PartyId,
                VoucherTypeId: item.VoucherTypeId,
                RefVoucherTypeId: 31
            },
                response =>
                    issuedItem = response.Entity,
                { async: false });

            //    VoucherTypeId: item.RefVoucherId
            //},
            //    response =>
            //        issuedItem = response.Entity,
            //    { async: false });


            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                if (value > issuedItem.Pieces) {
                    q.Alert('Invalid Entry', 'Entered pieces are more than  available stock', 2500, false);
                    item[field] = issuedItem.Pieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    
                }
                item[field] = value;

                this.view.updateItem(id, item);
                this.view.refresh();
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                if (value > issuedItem.Weight) {
                    q.Alert('Invalid Entry', 'Entered weight is more than available stock', 1000, false);
                    item[field] = issuedItem.Weight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                  
                }
                item[field] = value;

                this.view.updateItem(id, item);
                this.view.refresh();
            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as Purchase.ApprovalInReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);


            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "stock-button",
                hotkey: "alt+k",
                onClick: () => {

                    // **** Validate Party before Item Selection ****
                    var grid = PurchaseApprovalGrid;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            InStock: false,
                            PartyId: this.PartyId
                        } 
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.RefTransItemId == t.TransItemId) });

                        var ItemDetails: ApprovalInItemsRow[] = ItemGridHelper.SetReturnItemGrid(selectedItems2);

                        ItemDetails.forEach(function (Item) {
                            Item.BOMDetails.forEach(function (BOM) {
                                delete BOM.SBomRate;
                            });
                        })

                        

                        if (this.view.getItems().length > 0) {
                            this.TotalItems = ItemDetails.length + this.view.getItems().length;
                        }
                        else {
                            this.TotalItems = ItemDetails.length;
                        }
                        for (let Item of ItemDetails) {
                            Item[this.getIdProperty()] = "`" + this.nextId++; 
                            this.view.addItem(Item);
                        }
                    }
                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }

        // #endregion

        getItemData(items) {
            let x;
            for (let rateitem of items) {
                rateitem[this.getIdProperty()] = "`" + this.nextId++;
                x.push(rateitem);
            }
            return x;
        }
        
    }
}